import GameInfoComponent from '../components/GameLibrary/GameInfoComponent';
import {useParams} from "react-router-dom";

const GameInfoPage = () => {
  let { gameId } = useParams();
  return <GameInfoComponent gameId={gameId}/>;
};

export default GameInfoPage;
